var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLargeTwitch = function SvgLargeTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.168 15.082 21.5 18.75h-3.666l-3.208 3.208v-3.208h-4.125V4.999h14.666z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M9.585 3.168 5.002 7.751V24.25h5.5v4.583l4.583-4.583h3.666L27 16V3.168zm15.582 11.916-3.666 3.666h-3.667l-3.208 3.208V18.75h-4.124V5.001h14.665z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9146FF",
    d: "M22.42 8.21h-1.833v5.5h1.833zM17.373 8.21H15.54v5.5h1.833z"
  })));
};
export default SvgLargeTwitch;